import { render, staticRenderFns } from "./AdminCompanyGeneralSection.vue?vue&type=template&id=93903d74&"
import script from "./AdminCompanyGeneralSection.vue?vue&type=script&lang=ts&"
export * from "./AdminCompanyGeneralSection.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCompanyGeneralSection.vue?vue&type=style&index=0&id=93903d74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports